import { Card, Grid, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { VoucherActivateForm } from '@/features/voucher/VoucherActivateForm'

/**
 * Bitta ustunga sig'adigan kenglik — kassa ekranidagi bilan bir xil.
 * Ekranda ikkita maydon bor, undan kengi bo'sh joy bo'lardi.
 */
const MAX_WIDTH = 560

/**
 * «Karta faollashtirish» — egasi talabi (2026-08-23):
 *
 * > «Agent va reseller dashboardda vaucherni ishlata olish funksiyasi
 * > yo'q, shuni ham to'g'rila.»
 *
 * <h2>⚠️ 2026-08-25: AMAL KASSA EKRANIGA KO'CHDI, SAHIFA QOLDI</h2>
 * Egasi qarori: «karta faollashtirish menyu kerakmas, uni kassa
 * menyuga olib o'tsak bo'ladi, chunki uni vazifasi ham shunaqa».
 * Forma endi `CashdeskPage` da yig'ilgan bo'lim sifatida turadi va
 * menyuda alohida band YO'Q.
 *
 * ⛔ SAHIFA O'CHIRILMADI va bu quyidagi birinchi sababning to'g'ridan-
 * to'g'ri natijasi: `voucher.activate` kassa bayrog'idan MUSTAQIL,
 * ya'ni kassasiz reseller Kassa ekranini umuman ko'rmaydi. U uchun
 * `useVisibleNav` shartli band chizadi va yo'l shu sahifaga olib
 * keladi. Sahifani o'chirish o'sha sherikni serverda BOR huquqdan
 * jimgina mahrum qilardi.
 *
 * <h2>⚠️ QUYIDAGI UCH SABAB HAMON KUCHDA — ular «ALOHIDA EKRAN»
 * uchun edi, «alohida MENYU BANDI» uchun emas</h2>
 * Ya'ni forma Kassa sahifasida bo'lsa ham, u kassa OQIMINING qadami
 * emas: o'z formasi, o'z shartnomasi va pulsiz natijasi bilan
 * qoladi. Uchalasi ham o'lchangan:
 *
 * <ol>
 *   <li><b>Huquq boshqa.</b> Kassa ekrani `subscriber.directory` ga
 *       bog'langan va u KASSA bayrog'i (`CASH_DESK`, ADR-029 §2).
 *       `voucher.activate` esa IKKALA turning BAZAVIY to'plamida
 *       (`PartnerKind.java:55` va `:92`), ya'ni kassasiz reseller
 *       (`cash_desk = f`) ham unga haqli. Amalni kassa kartochkasiga
 *       qo'yish uni o'sha resellerdan jimgina olib qo'yardi — bu
 *       2026-08-21 da «Amallarim» bilan sodir bo'lgan nuqsonning
 *       aynan takrori bo'lardi.</li>
 *
 *   <li><b>Shartnoma boshqa.</b> Endpoint `login` ni SATR sifatida
 *       oladi va login topilmasa YANGI abonent ochadi
 *       (`VoucherServiceImpl.findOrCreate`). Kassa oqimi esa
 *       TOPILGAN abonentdan boshlanadi (`DirectoryRow`, `id` bo'yicha)
 *       — u «karta bilan yangi abonent» holatini umuman ifodalay
 *       olmaydi.</li>
 *
 *   <li><b>Pul harakati yo'q.</b> Grant `charge = false` bilan
 *       beriladi, ya'ni kassirning depoziti ham, abonentning balansi
 *       ham tegilmaydi. `useCashOperation` ning uch tovushi
 *       (`success`/`partial`/`refused`) bu yerda ma'nosiz: «mablag'
 *       yetmadi» degan holat yo'q.</li>
 * </ol>
 *
 * <h2>⚠️ MENYUDA — FAQAT KASSASIZ SHERIKDA</h2>
 * Band `VOUCHER_FALLBACK_ITEM` va u `useVisibleNav` da SHARTLI:
 * Kassani ko'radigan sherikda chizilmaydi, chunki forma o'sha
 * ekranning ichida. Ikkalasini birga ko'rsatish bitta amalni ikki
 * joyga qo'yardi.
 */
export function VoucherPage() {
  const { t } = useTranslation()
  const screens = Grid.useBreakpoint()
  const isMobile = screens.md === false

  return (
    <div style={{ maxWidth: MAX_WIDTH, margin: '0 auto' }}>
      {/* Sarlavha faqat kompyuterda — telefonda uni kabinetning yuqori
          qatori ko'rsatadi (`MyLoginsPage` bilan bir xil qaror). */}
      {isMobile ? null : (
        <div style={{ marginBottom: 16 }}>
          <Typography.Title level={4} style={{ margin: 0 }}>
            {t('vouchers.title')}
          </Typography.Title>
          <Typography.Text type="secondary">{t('vouchers.subtitle')}</Typography.Text>
        </div>
      )}

      <Card size="small">
        <VoucherActivateForm />
      </Card>
    </div>
  )
}
